'use client'

import { CSSProperties, ReactNode } from 'react'
import { ConsentGate } from '@/features/gdpr/consent-gate'
import { MAPS_INTEGRATION_ID, MapsApiProvider } from '@/features/gdpr/maps-api-provider'
import { MapPlaceholder } from '@/features/gdpr/placeholders/map-placeholder'
import { THIRD_PARTY_PURPOSE } from '@/features/gdpr/use-purpose-consent'

interface IMapConsentGateProps {
    className?: string
    style?: CSSProperties
    children: ReactNode
}

export const MapConsentGate = ({ className, style, children }: IMapConsentGateProps) => (
    <ConsentGate
        integrationId={MAPS_INTEGRATION_ID}
        purposeId={THIRD_PARTY_PURPOSE}
        placeholder={(activate) => (
            <MapPlaceholder onActivate={activate} className={className} style={style} />
        )}
    >
        <MapsApiProvider>{children}</MapsApiProvider>
    </ConsentGate>
)
